import InputNumeric from "./InputNumeric";
import InputWeight from "./InputWeight";

const QuantityInput = (props) => {
    return props.unit === "UNIT" ? (
        <InputNumeric {...props} />
    ) : (
        <InputWeight {...props} />
    );
};

export default QuantityInput;